module.exports = __webpack_public_path__ + "img/catalogo-2023.5da9abcc.jpg";